import { gql } from '@apollo/client';
import LESSON_COMPLETION_STATS_FRAGMENT from './lesson-completion-stats';

const LESSON_FRAGMENT = gql`
  fragment BaseLessonFragment on PrmCurriculumLessonDetail {
    lessonId
    completionStats {
      ...BaseLessonCompletionStatsFragment
    }
    averageTimeSpentSeconds
    lesson {
      id
      lessonNumber
      title
      primarySkillPhonics
      primarySkillWordStudy
    }
  }
  ${LESSON_COMPLETION_STATS_FRAGMENT}
`;

export default LESSON_FRAGMENT;
